/**
 * React entry point.
 *
 * Boot order:
 *   1. initReporter() — wires window.onerror + unhandledrejection so any
 *      crash *before* React mounts still reaches our reporter.
 *   2. createRoot(...) — mounts <App />. App.tsx wraps the tree in the
 *      AppErrorBoundary (pre-providers) and per-route RouteErrorBoundary
 *      (post-providers). Both boundaries call into reportError().
 *
 * We deliberately drop the previous <Sentry.ErrorBoundary> wrapper: the
 * AppErrorBoundary inside App.tsx is provider-tree safe and reports to
 * the same surface, so wrapping it adds zero value and the extra layer
 * was holding a TS error in place.
 */
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initReporter } from "./sentry";

initReporter();

createRoot(document.getElementById("root")!).render(<App />);
